import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row justify-content-center"
}
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_5 = { class: "row justify-content-center mt-2" }
const _hoisted_6 = { class: "col-12 col-sm-10 d-grid gap-2" }
const _hoisted_7 = { class: "row justify-content-left" }
const _hoisted_8 = {
  key: 0,
  class: "row justify-content-center"
}
const _hoisted_9 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_10 = { class: "col-1 mt-3 mb-3" }
const _hoisted_11 = { class: "progress-spinner progress-spinner-double size-sm progress-spinner-active" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_14 = { class: "visually-hidden" }
const _hoisted_15 = {
  key: 1,
  class: "col-xl-10 col-12"
}
const _hoisted_16 = {
  class: "section primary-bg-a1 p-4",
  "aria-describedby": "sectionServiceTitle"
}
const _hoisted_17 = { class: "section-content" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = {
  style: {"text-align":"left"},
  class: "col-12 mb-3"
}
const _hoisted_20 = { id: "sectionServiceTitle" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  style: {"min-height":"32px"},
  class: "d-flex"
}
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 1,
  class: "accordion accordion-left-icon",
  id: "accordionDocuments",
  style: {"border-bottom":"unset"}
}
const _hoisted_25 = { class: "accordion-item primary-bg-a1" }
const _hoisted_26 = {
  class: "accordion-header",
  id: "heading1"
}
const _hoisted_27 = {
  href: "#",
  role: "button",
  class: "btn accordion-button p-0",
  style: {"border-top":"unset"},
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseListDocument",
  "aria-expanded": "true",
  "aria-controls": "collapseListDocument"
}
const _hoisted_28 = {
  id: "collapseListDocument",
  class: "accordion-collapse collapse show list-documents",
  "data-bs-parent": "#accordionDocuments",
  role: "region",
  "aria-labelledby": "heading1"
}
const _hoisted_29 = { class: "accordion-body pb-0" }
const _hoisted_30 = { class: "it-list-wrapper" }
const _hoisted_31 = {
  key: 0,
  style: {"text-align":"left"}
}
const _hoisted_32 = ["href"]
const _hoisted_33 = {
  class: "it-list",
  style: {"list-style-type":"disc"}
}
const _hoisted_34 = {
  class: "list-item",
  style: {"border-bottom":"unset"}
}
const _hoisted_35 = {
  class: "it-right-zone",
  style: {"margin-left":"unset","margin-right":"unset","padding-top":"8px","padding-bottom":"8px"}
}
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "row" }
const _hoisted_38 = {
  style: {"text-align":"left"},
  class: "col-12 mb-3 mt-5"
}
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = {
  class: "pb-1",
  for: "bookingDetails"
}
const _hoisted_41 = {
  id: "formGroupUserNote",
  class: "form-text"
}
const _hoisted_42 = { key: 2 }

import api from "@/services/BookingService";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { FlowItem } from "@/models/Configuration/FlowItem";
import { TreeItem } from "@/models/Configuration/TreeItem";
import { ServiceModel } from "@/models/Step/ServiceModel";
import _ from "lodash";
import { computed, onMounted, onUnmounted, ref, watch, inject, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import BookflowSelect from "../../components/BookflowSelect.vue";
import constants from "@/models/Utils/constants";
import { Collapse } from "bootstrap-italia";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookService',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const tenantConfig = useTenantConfig();
const { t } = useI18n();
const emitter = inject("emitter");

const bookingFlow = ref<TreeItem<FlowItem>[]>([]);
const firstLevelBooking = ref<TreeItem<FlowItem>>(null);
const selectedNodes = ref([]);

const showTitle = ref(false);
const hasMunicipalityChoiceActive = ref(false);

const loadingService = ref(false);
const selectedItem = ref(null);
const selectedServiceDetail = ref(null);
const selectedServiceDetailDocuments = ref([]);
const error = ref(false);
const errorMessage = ref("");
const userNotes = ref("");

const initBookingFlow = () => {
    if (
        _.isNull(store.tenantConfig) === false &&
        _.isUndefined(store.tenantConfig) === false &&
        _.isNull(store.tenantConfig.bookingFlow) === false &&
        _.isUndefined(store.tenantConfig.bookingFlow) === false
    ) {
        bookingFlow.value = store.tenantConfig.bookingFlow;
        firstLevelBooking.value = bookingFlow.value[0];
        showTitle.value = true;
    } else {
        bookingFlow.value = [];
        firstLevelBooking.value = null;
        showTitle.value = false;
    }
};

const serviceSelected = (selectedNode: any) => {
    goAheadTreeNavigation(selectedNode.node, selectedNode.level);
};

const existsFlow = computed(() => {
    return bookingFlow.value.length > 0;
});

const existsDocumentsLink = computed(() => {
    if((t("common.requestedDocumentsLinkText") != 'common.requestedDocumentsLinkText' && t("common.requestedDocumentsLinkText").length > 0) && (t("common.requestedDocumentsLink") != 'common.requestedDocumentsLink' && t("common.requestedDocumentsLink").length > 0)){
        return true;
    }
    else{
        return false;
    }
});

onMounted(() => {
    store.stepsMade.service = null;
    store.stepsMade.location = null;
    store.stepsMade.details = null;

    // nextTick(() => {
    //   var accordions = [].slice.call(document.querySelectorAll(`.accordion`))
    //   accordions.forEach(function (el) {
    //     (Collapse as any).getOrCreateInstance(el);
    //   })
    // });

    emitter.on(constants.GO_NEXT_STEP, () => {
        goToNextStep();
    });
});

const goAheadTreeNavigation = (node: TreeItem<FlowItem>, level: number) => {
    if (node !== null && node !== undefined) {
        var splittedNodes: string[] = [];
        if (route.params.id as string) {
            splittedNodes = (route.params.id as string).split(",");
        }
        if (splittedNodes[level]) {
            splittedNodes[level] = node.item.id.toString();
            splittedNodes = splittedNodes.slice(0, level + 1);
        } else {
            splittedNodes.push(node.item.id.toString());
        }
        router.replace({
            name: "bookservicechoice",
            params: {
                id: splittedNodes.join()
            }
        });

        if (node.item.isService) {
            selectedItem.value = node;
            getSelectedServiceDetail();
        } else {
            selectedItem.value = null;
            selectedServiceDetail.value = null;
        }
    }
};

const getImageSrc = (node: TreeItem<FlowItem>) => {
    return tenantConfig.getImageSourceOfNode(node);
};

const getSelectedServiceDetail = () => {
    loadingService.value = true;
    api.getService(parseInt(selectedItem.value.item.service.id))
        .then((res) => {
            if (res && res.data) {
                loadingService.value = false;
                selectedServiceDetail.value = res.data;
            }
        })
        .catch((err) => {
            if (err && err.response) {
                if (err.response.status === 500) {
                    if (err.response.data && err.response.data.errorMessage) {
                        errorMessage.value = err.response.data.errorMessage;
                    }
                }
            }
            error.value = true;
            loadingService.value = false;
        });
};

const goToNextStep = () => {
    // Set current selection
    var node = selectedItem.value;
    if (node.item.isService) {
        store.stepsMade.details = userNotes.value;

        const service = new ServiceModel();
        service.id = selectedItem.value.item.service.id;
        service.name = selectedItem.value.item.service.name;
        service.privacyPolicyId = selectedItem.value.item.service.privacyPolicyId;
        store.stepsMade.service = service;

        const locationRouteSelection = tenantConfig.getRouteNameLocationSelection();

        if (node.item.isService && node.item.service.typeId == 2) {
            router.push({ name: "recalluserdata" });
        } else {
            hasMunicipalityChoiceActive.value = tenantConfig.hasMunicipalityChoiceActive.value;

            if (hasMunicipalityChoiceActive.value) {
                if (store.stepsMade && store.stepsMade.municipality) {
                    router.push({ name: locationRouteSelection });
                } else {
                    router.push({ name: "municipality" });
                }
            } else {
                router.push({ name: locationRouteSelection });
            }
        }
    }
};

watch(
    () => route.params.id,
    () => {
        if (bookingFlow.value.length === 0) {
            initBookingFlow();
        }
        if (route.params && route.params.id) {
            if (bookingFlow.value.length > 0) {
                var splittedNodes = (route.params.id as string).split(",");
                selectedNodes.value = [];
                for (let index = 0; index < splittedNodes.length; index++) {
                    selectedNodes.value.push(splittedNodes[index]);
                }
            }
        }
        //caso url del tipo bookingflow
        else {
            if (bookingFlow.value.length > 0) {
                firstLevelBooking.value = bookingFlow.value[0];
                //Commentato per impedire che al caricamento fosse prepopolata la prima scelta
                //serviceSelected({ node: bookingFlow.value[0].children[0], level: 0 });
            }
        }
    },
    { immediate: true }
);

watch(
    () => selectedServiceDetail.value,
    (newVal) => {
        if (newVal) {
            if (!newVal.alertTypeId || newVal.alertTypeId === 1) {
                emitter.emit(constants.CAN_GO_NEXT_STEP, true);
            } else {
                emitter.emit(constants.CAN_GO_NEXT_STEP, false);
            }
        } else {
            emitter.emit(constants.CAN_GO_NEXT_STEP, false);
        }
    },
    { immediate: true }
);

const documentsFromBooking = computed(() => {
    const documents: string[] = [];
    if (selectedServiceDetail.value.serviceInfo) {
        var docs = selectedServiceDetail.value.serviceInfo.split("|");

        for (var j = 0; j < docs.length; j++) {
            if (
                documents.some(function (item) {
                    return item == docs[j];
                }) == false
            ) {
                documents.push(docs[j]);
            }
        }
    }

    return documents;
});

onUnmounted(() => emitter.off(constants.GO_NEXT_STEP));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (showTitle.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (firstLevelBooking.value && firstLevelBooking.value.item.title)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_unref(t)("titles.scheduleBooking")), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (existsFlow.value && firstLevelBooking.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(BookflowSelect, {
                  nodes: firstLevelBooking.value.children,
                  title: firstLevelBooking.value.item.title,
                  level: 0,
                  onServiceSelected: serviceSelected,
                  selectednodes: selectedNodes.value
                }, null, 8, ["nodes", "title", "selectednodes"])
              ])
            ])
          ]),
          (selectedItem.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (loadingService.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _hoisted_13,
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)("common.loadingText")), 1)
                        ])
                      ])
                    ]))
                  : (selectedServiceDetail.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("section", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("label", null, _toDisplayString(_unref(t)("titles.selectedService")), 1),
                                _createElementVNode("h3", _hoisted_20, _toDisplayString(selectedServiceDetail.value.name), 1),
                                _createElementVNode("p", {
                                  innerHTML: selectedServiceDetail.value.description
                                }, null, 8, _hoisted_21)
                              ])
                            ]),
                            (selectedServiceDetail.value.alertTypeId)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["text-start alert", selectedServiceDetail.value.alertTypeId === 1 ? 'alert-warning' : 'alert-danger']),
                                  role: "alert"
                                }, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("span", {
                                      class: "align-self-center",
                                      innerHTML: selectedServiceDetail.value.alertMessage
                                    }, null, 8, _hoisted_23)
                                  ])
                                ], 2))
                              : _createCommentVNode("", true),
                            (documentsFromBooking.value && documentsFromBooking.value.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("h2", _hoisted_26, [
                                      _createElementVNode("a", _hoisted_27, _toDisplayString(_unref(t)("common.requestedDocuments")), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("div", _hoisted_30, [
                                          (existsDocumentsLink.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                _createElementVNode("h6", null, [
                                                  _createElementVNode("a", {
                                                    href: _unref(t)('common.requestedDocumentsLink'),
                                                    target: "_blank"
                                                  }, _toDisplayString(_unref(t)("common.requestedDocumentsLinkText")), 9, _hoisted_32)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("ul", _hoisted_33, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentsFromBooking.value, (doc, index) => {
                                              return (_openBlock(), _createElementBlock("li", { key: index }, [
                                                _createElementVNode("div", _hoisted_34, [
                                                  _createElementVNode("div", _hoisted_35, [
                                                    _createElementVNode("span", { innerHTML: doc }, null, 8, _hoisted_36)
                                                  ])
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("label", _hoisted_40, _toDisplayString(_unref(t)("common.bookingDetails")), 1),
                              _withDirectives(_createElementVNode("textarea", {
                                id: "bookingDetails",
                                rows: "3",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userNotes).value = $event)),
                                autocomplete: "off"
                              }, null, 512), [
                                [_vModelText, userNotes.value]
                              ]),
                              _createElementVNode("small", _hoisted_41, _toDisplayString(_unref(t)("messages.textLengthAllowed")), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!existsFlow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("h5", null, _toDisplayString(_unref(t)("messages.noAvailability")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})